<ng-container *transloco="let t; read: 'shared'">
  <span class="title">{{ t("dialogs.tooManyUsers.title") }}</span>
  <span>{{ t("tooManyUsers", { users: TOO_MANY_USERS_THRESHOLD }) }}</span>

  <div class="button-container">
    <app-button
      backgroundColor="var(--bnear-brand)"
      border="1.5px solid transparent"
      class="confirm-button absolute-css-values"
      color="white"
      height="unset"
      padding="5px 20px"
      (buttonClick)="cancel()"
    >
      {{ t("dialogs.cancel") }}
    </app-button>

    <app-button
      backgroundColor="transparent"
      border="1.5px solid var(--bnear-brand)"
      class="absolute-css-values"
      color="var(--bnear-brand)"
      height="unset"
      padding="5px 20px"
      (buttonClick)="confirm()"
    >
      {{ t("dialogs.tooManyUsers.confirm") }}
    </app-button>
  </div>
</ng-container>
